<script setup>
import {computed, ref} from 'vue';
import vidu_logo from "@/assets/vidu_logo.png";
import telegram from "@/assets/telegram.png";
import youtube from "@/assets/youtube.png";
import mir from "@/assets/mir.png";
import mastercard from "@/assets/mastercard.png";
import visa from "@/assets/visa.png";
import ThemeToggler from "@/components/ThemeToggler.vue";
import {isAuthenticated, logout} from "@/helpers/back";
import {domainName, getHost} from "@/helpers/h2";

const v = ref(process.env.VUE_APP_VERSION);
const is_auth = computed( () => isAuthenticated())
const logout_ = async () => await logout()
</script>
<template>

    <footer class="footer-section bg-dark-section text-white">
        <div class="container pt-5 pb-4">

          <div class="row">

            <div class="col-12 col-md-4">
              <div class="footer-logo mb-4">
                <img alt="Vidu" class="img-fluid" :src="vidu_logo" style="height:40px;"/>
              </div>
              <p>
                Vidu — качественный плеер для видео и трансляций. Вы можете зарабатывать на продаже лицензии без сложных настроек.
              </p>
            </div>

            <div class="col-12 col-md-4">
              <h6 class="mb-3">Документы</h6>
              <ul class="list-unstyled">
                <li>
                  <router-link to="/license" class="footer-link">
                    Лицензионное соглашение
                  </router-link>
                </li>
                <li>
                  <router-link to="/confidential" class="footer-link">
                    Политика конфиденциальности
                  </router-link>
                </li>
                <li>
                  <router-link to="/agreement" class="footer-link">
                    Соглашение об использовании видеоплеера
                  </router-link>
                </li>
                <li>
                  <router-link to="/tarif" class="footer-link">
                    Тарифы
                  </router-link>
                </li>
                <li>
                  <router-link to="/unsubscribe" class="footer-link">
                    Отписка
                  </router-link>
                </li>
              </ul>
            </div>


            <div class="col-12 col-md-2">
              <h6 class="mb-3">Контакты</h6>

              <ul class="list-unstyled">
                <li><a :href="`mailto:support@${domainName()}`" class="footer-link">support@{{ domainName() }}</a></li>
                <li>ИП Ахмадуллин И.И.</li>
              </ul>

              <div class="cards-icons d-flex flex-row gap-2">
                <img alt="mir" class="" :src="mir"/>
                <img alt="mastercard" class="" :src="mastercard"/>
                <img alt="visa" class="" :src="visa"/>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <h6 class="mb-3">Следите за нами</h6>
              <a class="me-3 text-white" href="#"><img alt="Telegram" :src="telegram" style="height:34px;"/></a>
              <a class="text-white" href="#"><img alt="YouTube" :src="youtube" style="height:26px;"/></a>
            </div>
          </div>

            <hr class="my-4 border-secondary" />

            <div class="row">
                <div class="col-12 text-center small d-flex flex-row">
                  <span class="flex-grow-1">© 2025 Vidu. Все права защищены. v.{{ v }}</span>

                  <div class="ms-auto d-flex flex-row gap-3">
                    <div class="ms-auto">
                      <ThemeToggler />
                    </div>
                  </div>

                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.cards-icons img{
  height: 20px;
  width: auto;
  vertical-align: middle;
}
</style>